import it from '@/lang/it'

export default {
    it
}


// WEBPACK FOOTER //
// ./src/lang/_langs.js